export const MODEL_FORM_ID = 'model-form';

export enum MeterModelFilesCardType {
  Model = 'model',
  Module = 'module',
  Meter = 'meter',
}
